import Api from './Api.service';
export default class UsuarioService {
    static ObtenerTodo() {
        return Api.get("usuario");
    }
    static Insertar(model) {
        return Api.post('usuario/insertar', model);
    }
    static Modificar(model) {
        return Api.post('usuario/modificar', model);
    }
    static Eliminar(usuarioid) {
        return Api.delete(`usuario/eliminar/${usuarioid}`);
    }
    static ObtenerTodoPaginado(dni, pagina, cantidad) {
        let params = "?";
        if (dni)
            params += `dni=${dni}&`;
        if (pagina)
            params += `pagina=${pagina}&`;
        if (cantidad)
            params += `cantidad=${cantidad}&`;

        return Api.get(`usuario/paginado${params}`);
    }

}